import {buildQueryParams} from "../../utils";
import {useApi} from "../Api";
import {FilteredRequest, PagedResponse} from "../types/pagination";
import {
    FormSearchUpsellingRateModel,
    UpsellingRateEntityRequest,
    UpsellingRateEntityResponse
} from "../types/upsellingRate";

export const useUpsellingRateRepository = () => {
    const {GET, POST, PUT, DELETE} = useApi();

    const PATH = "/pricing/upselling-rate";

    function getUpsellingRate(upsellingRateId: number): Promise<UpsellingRateEntityResponse> {
        return GET(`${PATH}?id=${upsellingRateId}`);
    }

    function putUpsellingRate(upsellingRate: UpsellingRateEntityResponse): Promise<UpsellingRateEntityResponse> {
        return PUT(`${PATH}`, upsellingRate);
    }

    function putUpsellingRateList(upsellingRateList: UpsellingRateEntityResponse): Promise<UpsellingRateEntityResponse> {
        return PUT(`${PATH}`, upsellingRateList);
    }

    function deleteUpsellingRate(upsellingRateId: number): Promise<number> {
        return DELETE(`${PATH}?id=${upsellingRateId}`);
    }

    function terminateUpsellingRate(upsellingRateId: number): Promise<UpsellingRateEntityResponse> {
        return GET(`${PATH}/terminate?id=${upsellingRateId}`);
    }

    function postUpsellingRateList(upsellingRateList: UpsellingRateEntityRequest): Promise<UpsellingRateEntityResponse> {
        return POST(`${PATH}`, upsellingRateList);
    }

    function getUpsellingRateFiltered(request: FilteredRequest<UpsellingRateEntityResponse>): Promise<PagedResponse<UpsellingRateEntityResponse>> {
        return GET(`${PATH}/filter`, {
            params: request,
            paramsSerializer: buildQueryParams
        });
    }

    function getUpsellingRatePaged(filters: FormSearchUpsellingRateModel): Promise<PagedResponse<UpsellingRateEntityResponse>> {
        const query = "?";

        const queryParams = buildQueryParams(filters);

        return GET(`${PATH}/filter${queryParams ? query + queryParams : ""}`);
    }

    function getUpsellingRateInUse({upsellingRateId}: { upsellingRateId: number }): Promise<boolean> {
        return GET(`${PATH}/in-use?id=${upsellingRateId}`);
    }

    return {
        deleteUpsellingRate,
        postUpsellingRateList,
        putUpsellingRateList,
        getUpsellingRatePaged,
        getUpsellingRateInUse,
        terminateUpsellingRate
    };
};
